import ApiWithFileUpload from './ApiWithFileUpload';

export default ApiWithFileUpload;
